import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=e73552fc&scoped=true&"
import script from "./Sample.vue?vue&type=script&lang=js&"
export * from "./Sample.vue?vue&type=script&lang=js&"
import style0 from "./Sample.vue?vue&type=style&index=0&id=e73552fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73552fc",
  null
  
)

export default component.exports